export enum TimeClass {
    TRABALHANDO = 1,
    PARADO = 2,
    MANUTENCAO = 3
}